var map = {
	"./bg_map.png": "d918",
	"./chatbot_pattern.png": "878e",
	"./clock.png": "2b5f",
	"./close-circle.png": "5112",
	"./content-cut.png": "b20f",
	"./f0.png": "765c",
	"./f0_activa.png": "fc2a",
	"./f1.png": "46fd",
	"./f1_activa.png": "4cc4",
	"./f2.png": "a2b5",
	"./f2_activa.png": "4bf8c",
	"./falla_inactiva.png": "19bf",
	"./format-horizontal-align-center.png": "2b82",
	"./google-marker-blue-dot.png": "473a",
	"./google-marker-red-dot.png": "6653",
	"./logo.png": "cf05",
	"./stop0.png": "949d",
	"./stop1.png": "00bb",
	"./stop2.png": "f5f6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9e01";